var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 197,
    viewBox: "0 0 155 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0209 131.499C10.5232 179.163 57.0366 196.499 79.5287 196.499C113.522 196.499 149.036 173.739 149.036 131.499C149.036 91.5105 105.547 59.4202 83.2551 16.6289C80.9085 12.1245 72.5926 12.6258 70.7035 17.3405C53.07 61.3492 8.00194 99.1693 9.0209 131.499Z",
    fill: "#F19B38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0092 146.862C48.6636 167.495 68.9249 174.999 78.7225 174.999C93.5299 174.999 109 165.147 109 146.862C109 130.149 94.3037 112.693 83.2054 101.191C80.4388 98.3243 75.8293 98.4424 73.217 101.451C62.4084 113.898 47.578 133.265 48.0092 146.862Z",
    fill: "#FFD646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6958 50.4471L9.36725 129.206L67.4905 92.4527L30.7637 45.509C25.6774 39.0078 15.253 42.2116 14.6958 50.4471Z",
    fill: "#F19B38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.826 51.2494L148 120L96.5922 100.881L128.495 49.8272C130.436 46.7199 135.187 47.6415 135.826 51.2494Z",
    fill: "#F19B38"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.65d0124529e37f60a1169ecce34b4c51.svg";
export { ForwardRef as ReactComponent };